export default __webpack_public_path__ + "locales/fr/SocialAuthWelcomeDialog.json?hash=fa7b0cd3a2eef476da19d4b59b395fb4";